import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { sendOtp, verifyOtp, resendOtp } from "../../lib/sessionClient";
import useApiStatus from "../../CustomHooks/useApiStatus";
import useOtpInput from "../../CustomHooks/useOtpInput";
import useOtpTimer from "../../CustomHooks/useOtpTime";
import OtpSendForm from "../../components/auth/OtpSendForm";
import OtpVerificationForm from "../../components/auth/OtpVerificationForm";
import LoginHeader from "../../components/auth/LoginHeader";

const LoginPage = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const phone = getValues("phone");

  const [sendStatus, sendRunner] = useApiStatus();
  const [verifyStatus, verifyRunner] = useApiStatus();
  const [resendStatus, resendRunner] = useApiStatus();

  const {
    otp,
    inputRefs,
    handleOtpChange,
    handleKeyDown,
    handlePaste,
    setOtp,
  } = useOtpInput();
  const { timeLeft, active: timerActive, reset, setActive } = useOtpTimer(30);

  // ===============================================
  // SEND OTP HANDLER
  // ===============================================
  const sendOtpHandler = (data) => {
    sendRunner(async () => {
      const res = await sendOtp(data.phone);
      setActive(true);
      return res;
    });
  };

  // ===============================================
  // VERIFY OTP HANDLER
  // ===============================================
  const verifyOtpHandler = () =>
    verifyRunner(async () => {
      const res = await verifyOtp(phone, otp.join(""));
      navigate("/home");
      return res;
    });

  // ===============================================
  // RESEND OTP HANDLER
  // ===============================================
  const resendOtpHandler = () =>
    resendRunner(async () => {
      const res = await resendOtp(phone);
      reset();
      setOtp(Array(6).fill(""));
      return res;
    });

  // check sent OTP is ok ?
  const otpSent = sendStatus.status === "OK";
  return (
    <div className="sm:flex sm:flex-wrap h-full">
      <LoginHeader />
      <div className="login-main">
        <div className="login-content">
          <div className="login-container">
            <form
              onSubmit={handleSubmit(
                otpSent ? verifyOtpHandler : sendOtpHandler,
              )}
            >
              {!otpSent ? (
                <OtpSendForm
                  register={register}
                  errors={errors}
                  {...sendStatus}
                />
              ) : (
                <OtpVerificationForm
                  phone={phone}
                  otp={otp}
                  timeLeft={timeLeft}
                  timerActive={timerActive}
                  inputRefs={inputRefs}
                  handleOtpChange={handleOtpChange}
                  handleKeyDown={handleKeyDown}
                  handlePaste={handlePaste}
                  resendOtpHandler={resendOtpHandler}
                  verifyStatus={verifyStatus}
                  resendStatus={resendStatus}
                />
              )}
            </form>
            <div className="mt-4 text-center text-sm text-gray-500">
              By continuing, you agree to our{" "}
              <Link
                to="/privacy-policy"
                className="font-medium text-dark-blue hover:underline"
              >
                Privacy Policy
              </Link>
              .
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
